import React from "react";
import { getMaybeActiveEmployeeOrLogin, getMaybeActiveUserOrRefresh } from "../api/serverApiHelpers";
import { Link } from "./Link";
import { apiEndpoints } from "../amorg-common";

export function FileLinkWithTokenRefresh(
    props:{
        publicFileName:string, 
        privateFileName:string,
        style?:React.CSSProperties
}):JSX.Element
{
    async function handleClick()
    {
        // Will refresh token if needed
        await getMaybeActiveUserOrRefresh();
        window.open(apiEndpoints.files_privateFileName.replace(':privateFileName', props.privateFileName), '_blank', 'noreferrer');
    }

    return (
        <FileLink style={{...props.style}} onClick={handleClick} fileName={props.publicFileName} />
    );
}

export function EmployeePortalFileLinkWithTokenRefresh(
    props:{
        publicFileName:string, 
        privateFileName:string, 
        style?:React.CSSProperties
}):JSX.Element
{
    async function handleClick()
    {
        // Will refresh token if needed
        await getMaybeActiveEmployeeOrLogin();
        window.open(apiEndpoints.portalfiles_privateFileName.replace(':privateFileName', props.privateFileName), '_blank', 'noreferrer');
    }

    return (
        <FileLink style={{...props.style}} onClick={handleClick} fileName={props.publicFileName} />
    );
}

export function FileLink(
    props:{
        fileName:string,
        href?:string
        style?:React.CSSProperties,
        onClick?: () => void
}):JSX.Element
{
    return (
        <Link style={{...props.style, cursor:'pointer'}} onClick={props.onClick} href={props.href}>
            {props.fileName}
        </Link>
    );
}